import AntButton, { type ButtonProps as AntButtonProps } from "antd/lib/button";
import clsx from "clsx";
import { forwardRef } from "react";

import styles from "./Button.module.css";

export type ButtonProps = Omit<AntButtonProps, "color"> & {
    /**
     * `warning` calls attention with the theme's warning colours, for actions that ask to revisit
     * work rather than destructive ones. Filled by default (tinted surface, dark label); `solid` for
     * a stronger call to action, or `outlined` for a bordered container surface.
     */
    color?: AntButtonProps["color"] | "warning";
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
    { className, type, danger, color, variant, ...props },
    ref,
) {
    const isWarning = "warning" === color;
    const warningVariant = variant ?? "filled";
    const isDefaultPrimary = (type === "default" || type === undefined) && !danger && !color;

    return (
        <AntButton
            ref={ref}
            type={type}
            danger={danger}
            // The theme's warning colour is antd's orange preset
            color={isWarning ? "orange" : color}
            variant={isWarning ? warningVariant : variant}
            className={clsx(
                styles.button,
                isDefaultPrimary && styles.defaultPrimary,
                isWarning && ("solid" === warningVariant ? styles.warningSolid : styles.warning),
                isWarning && "outlined" === warningVariant && styles.warningOutlined,
                className,
            )}
            {...props}
        />
    );
});
